"use client";
import {
  useGroupLabel
} from "./7CGRXEUR.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./YIF72NQG.js";
import {
  __objRest
} from "./4R3V3JGP.js";

// src/composite/composite-group-label.tsx
var TagName = "div";
var useCompositeGroupLabel = createHook(function useCompositeGroupLabel2(_a) {
  var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
  props = useGroupLabel(props);
  return props;
});
var CompositeGroupLabel = forwardRef(function CompositeGroupLabel2(props) {
  const htmlProps = useCompositeGroupLabel(props);
  return createElement(TagName, htmlProps);
});

export {
  useCompositeGroupLabel,
  CompositeGroupLabel
};
